import React, { lazy, Suspense } from 'react';

import { Balloon } from '@icedesign/base';
import { Panel } from '@icedesign/qrcode';

import { Link } from 'react-router-dom';

import { getAuthority } from '@/auth/authority';
import Auths from '@/auth/Auths';
import RequireAuthority from '@/auth/RequireAuthority';
import { formatMessage } from '@/i18n';
import Colors from '@/tool/Colors';
import { isMulti } from '@/tool/profile';

const FaMobile = lazy(() => import('react-icons/fa').then(mod => ({ default: mod.FaMobile })));
const FaUpload = lazy(() => import('react-icons/fa').then(mod => ({ default: mod.FaUpload })));

const AuthLink = RequireAuthority(Link);

export default ({ publicip, port, qrurl }) => {
  return (
    // 多企业总平台登录不显示
    (qrurl || (publicip && port)) &&
    !getAuthority().includes(Auths.ADMINISTRATOR) && (
      <Balloon
        trigger={
          <div className="setting-qr">
            <Suspense fallback={null}>
              <FaMobile size={16} />{' '}
            </Suspense>
          </div>
        }
        style={{ borderRadius: 8 }}
        closable={false}
        align="l"
      >
        <div style={{ textAlign: 'center', paddingTop: 5 }}>
          <Panel
            // TODO: 端口号是否需要现取，由于piblicip是ip形式，所以https协议基本上也就不用了...
            // TODO: 如果是域名访问的话，就不需要获取服务端ip和port了
            value={`${qrurl || `http://${publicip}${port === '80' ? '' : `:${port}`}`}/#/app`}
            // text={formatMessage('menu.app.qr.desc')}
          />
          <div
            style={{ marginTop: 10 }}
            dangerouslySetInnerHTML={{
              __html: formatMessage('menu.app.qr.desc'),
            }}
          />

          {/** *不是多企业的版本显示APP中心 */}
          {!isMulti() ? (
            <AuthLink auth={Auths.SUPER} style={styles.entrance} to="/system/appcenter">
              <Suspense fallback={null}>
                <FaUpload size={13} />
              </Suspense>{' '}
              &nbsp;&nbsp;{formatMessage('system.app')}
            </AuthLink>
          ) : (
            <></>
          )}
        </div>
      </Balloon>
    )
  );
};

const styles = {
  entrance: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 10,
    color: Colors.warning,
    cursor: 'pointer',
  },
};
